import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, postAPI, putAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { ButtonGroup, Button, Container, Row, Col, SegmentLoader } from '@si-armes/dsfr-react';
import {
    API_GENERER_CODE_VALIDATION,
    API_MODIFIER_ADRESSE_PRINCIPALE,
    API_POST_VERIFIER_BAN,
    API_RECUPERER_ADRESSE_PRINCIPALE,
    CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE,
    CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE,
    CONTEXT_GENERER_CODE_VALIDATION,
    CONTEXT_POST_VERIFIER_BAN,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import FormulaireAdresseSimple from 'components/form/formulaireAdresse/FormulaireAdresseSimple';
import FileUploadeBack from 'components/form/InputFiles/Model/FileUploadeBack';
import FormulaireJustificatifsDomicile from 'components/form/formulaireAdresse/FormulaireJustificatifsDomicile';
import ModalBan from 'components/modalBan/ModalBan';
import RoutesEcranGestion from '../gestion/routes';
import { getPath } from '../../../../utils/router';
import InfoChampsObligatoire from '../../../../components/form/infoObligatoire/InfoChampsObligatoire';
import ModaleVerificationCode from '../components/ModaleVerificationCode';

const ModificationAdressePrincipale = ({
    getApi,
    postApi,
    putApi,
    reinitialiseApi,
    dataAdresse,
    isLoadingAdresse,
    dataBan,
    isLoadingBan,
    isLoadingModificationAdresse,
    erreurModificationAdresse,
    dataCodePostal,
    dataCompteUsager,
    isLoadingVerificationCodeValidation,
    erreurVerificationCodeValidation,
    messageVerificationCodeValidation,
}) => {
    const { idAdresse } = useParams();
    const history = useHistory();
    const location = useLocation();
    const uniquidPersonnePhysique = location.state?.uniquidPersonnePhysique;
    const dataProviderPersonneCible = (data) =>
        uniquidPersonnePhysique ? data?.responsableLegal : data?.personnePhysique;
    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: {
            justificatifsDomicile: [],
        },
    });
    const { handleSubmit, reset, setValue, watch, setError, clearErrors, formState } = hookForm;
    const [dataToSubmit, setDataToSubmit] = useState(null);
    const [ouvrirModalBan, setOuvrirModalBan] = useState(false);
    const [nouveauJustificatifExige, setNouveauJustificatifExige] = useState(false);
    const [displayModaleVerificationCode, setdisplayModaleVerificationCode] = useState(false);
    const [dateGenerationCode, setDateGenerationCode] = useState(null);
    const [renvoyerCode, setRenvoyerCode] = useState(false);
    const [modeBan, setModeBan] = useState(null); // 'conserver' ou 'remplacer'

    useEffect(() => {
        const urlRecuperationAdresse = uniquidPersonnePhysique
            ? `${API_RECUPERER_ADRESSE_PRINCIPALE}${idAdresse}?uniquidPersonnePhysique=${uniquidPersonnePhysique}`
            : API_RECUPERER_ADRESSE_PRINCIPALE + idAdresse;
        getApi(
            usagerClientReducer,
            urlRecuperationAdresse,
            CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE,
        );
        return () => {
            reinitialiseApi(CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE);
            reinitialiseApi(CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE);
            reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        };
    }, []);

    useEffect(() => {
        if (!isLoadingAdresse && dataAdresse && dataAdresse.justificatifsDomicile) {
            const fichiersJustificatifs = dataAdresse.justificatifsDomicile.fichiers.map(
                (fichier) => {
                    return new FileUploadeBack(fichier);
                },
            );
            reset({
                numeroDeVoie: dataAdresse.numeroDeVoie,
                extension: dataAdresse.extension,
                typeEtNomDeVoie: dataAdresse.libelleVoie,
                lieuDit: dataAdresse.lieuDit,
                codePostal: dataAdresse.codePostal,
                ville: dataAdresse.ville,
                typeJustificatif: dataAdresse.typeJustificatif,
            });
            setValue('justificatifsDomicile', fichiersJustificatifs);
        }
    }, [isLoadingAdresse, dataAdresse]);

    useEffect(() => {
        if (!erreurModificationAdresse && isLoadingModificationAdresse === false) {
            history.push(getPath(RoutesEcranGestion));
        }
    }, [isLoadingModificationAdresse, erreurModificationAdresse]);

    useEffect(() => {
        if (dataAdresse && isLoadingAdresse === false) {
            if (
                (watch('numeroDeVoie') !== dataAdresse.numeroDeVoie ||
                    watch('extension') !== dataAdresse.extension ||
                    watch('typeEtNomDeVoie') !== dataAdresse.libelleVoie ||
                    watch('lieuDit') !== dataAdresse.lieuDit ||
                    watch('codePostal') !== dataAdresse.codePostal ||
                    watch('ville') !== dataAdresse.ville) &&
                watch('justificatifsDomicile')[0] &&
                watch('justificatifsDomicile')[0].uuid
            ) {
                setNouveauJustificatifExige(true);
                setError('justificatifsDomicile', {
                    type: 'manual',
                    message:
                        'Vous devez importer un nouveau justificatif de domicile correspondant à votre nouvelle adresse',
                });
            } else {
                setNouveauJustificatifExige(false);
                clearErrors('justificatifsDomicile');
            }
        }
    }, [
        watch('numeroDeVoie'),
        watch('extension'),
        watch('typeEtNomDeVoie'),
        watch('lieuDit'),
        watch('codePostal'),
        watch('ville'),
        watch('justificatifsDomicile'),
    ]);
    const verifierBan = (data) => {
        const adresseAverifier = {
            numeroDeVoie: data.numeroDeVoie,
            libelleVoie: data.typeEtNomDeVoie,
            codePostal: data.codePostal,
            ville: data.ville,
            extension: data.extension,
            lieuDit: data.lieuDit,
        };

        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setDataToSubmit(data);
        setOuvrirModalBan(true);
    };

    const onSubmit = async (dataToSend) => {
        const fichiers = [];
        for (let i = 0; i < dataToSend.justificatifsDomicile.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            fichiers[i] = await dataToSend.justificatifsDomicile[i].getFileToSend();
        }

        const adresseAModifier = {
            ...dataToSend,
            idAdresse: dataAdresse.id,
            justificatifsDomicile: fichiers,
            typeJustificatifDomicile: dataToSend.typeJustificatif,
            uniquidPersonnePhysique,
        };

        reinitialiseApi(CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE);
        putApi(
            usagerClientReducer,
            API_MODIFIER_ADRESSE_PRINCIPALE,
            adresseAModifier,
            CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE,
        );
    };

    const fermerModal = () => {
        setOuvrirModalBan(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };

    const redirectToEcranGestion = () => {
        history.push(getPath(RoutesEcranGestion));
    };

    const ouvrirModaleVerificationCode = () => {
        if (!dateGenerationCode) {
            const dateNow = new Date();
            setDateGenerationCode(dateNow);
            setRenvoyerCode(false);

            reinitialiseApi(CONTEXT_GENERER_CODE_VALIDATION);

            postApi(
                usagerClientReducer,
                API_GENERER_CODE_VALIDATION.replace(
                    '{uniquid}',
                    dataProviderPersonneCible(dataCompteUsager).uuid,
                ),
                {},
                CONTEXT_GENERER_CODE_VALIDATION,
            );
        }
        setdisplayModaleVerificationCode(true);
    };

    const conserver = () => {
        setModeBan('conserver');
        fermerModal();
        ouvrirModaleVerificationCode();
    };

    const remplacer = () => {
        setModeBan('remplacer');
        fermerModal();
        ouvrirModaleVerificationCode();
    };

    const fermerModaleVerificationCode = () => {
        setdisplayModaleVerificationCode(false);
    };

    const submitValider = () => {
        const data = hookForm.watch();
        if (!data || !formState.isDirty) return;

        if (modeBan === 'conserver') {
            onSubmit({ ...dataToSubmit, hasVerificationBan: false });
        } else if (modeBan === 'remplacer') {
            onSubmit({
                ...dataToSubmit,
                numeroDeVoie: dataBan?.numeroDeVoie || data.numeroDeVoie,
                typeEtNomDeVoie: dataBan?.libelleVoie || data.typeEtNomDeVoie,
                extension: dataBan?.extension || data.extension,
                lieuDit: dataBan?.lieuDit || data.lieuDit,
                codePostal: dataBan?.codePostal || data.codePostal,
                ville: dataBan?.ville || data.ville,
                hasVerificationBan: true,
            });
        }
    };

    return (
        <Container>
            <Row>
                <Col col={12}>
                    <h1>Modification de l&apos;adresse principale</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <InfoChampsObligatoire />
                </Col>
            </Row>
            <SegmentLoader isLoading={isLoadingAdresse || isLoadingModificationAdresse}>
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(verifierBan)}>
                        <FormulaireAdresseSimple />
                        <FormulaireJustificatifsDomicile />
                        <Row className="margin-top-lg">
                            <Col col={12}>
                                <ButtonGroup align="right" inline>
                                    <Button
                                        name="etapePrecedente"
                                        variant="secondary"
                                        onClick={redirectToEcranGestion}
                                    >
                                        Retour
                                    </Button>
                                    <Button
                                        name="validerAdresse"
                                        variant="primary"
                                        type="submit"
                                        disabled={
                                            nouveauJustificatifExige ||
                                            !formState.isDirty ||
                                            !dataCodePostal
                                        }
                                    >
                                        Valider
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </SegmentLoader>
            {ouvrirModalBan && (
                <ModalBan
                    residence="principale"
                    fermerModal={fermerModal}
                    data={dataBan}
                    isLoading={isLoadingBan}
                    remplacer={remplacer}
                    conserver={conserver}
                />
            )}

            <ModaleVerificationCode
                titre="Modification de l'adresse principale"
                fermerModale={fermerModaleVerificationCode}
                modaleOuverte={displayModaleVerificationCode}
                submitValider={submitValider}
                dataCompteUsager={dataCompteUsager}
                dateGenerationCode={dateGenerationCode}
                setDateGenerationCode={setDateGenerationCode}
                renvoyerCode={renvoyerCode}
                setRenvoyerCode={setRenvoyerCode}
                apiConfig={{ dataProvider: dataProviderPersonneCible }}
                getApi={getApi}
                postApi={postApi}
                reinitialiseApi={reinitialiseApi}
                isLoadingVerificationCodeValidation={isLoadingVerificationCodeValidation}
                erreurVerificationCodeValidation={erreurVerificationCodeValidation}
                messageVerificationCodeValidation={messageVerificationCodeValidation}
            />
        </Container>
    );
};

ModificationAdressePrincipale.propTypes = {
    getApi: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    putApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataAdresse: PropTypes.shape({
        numeroDeVoie: PropTypes.string,
        id: PropTypes.number,
        extension: PropTypes.string,
        libelleVoie: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string,
        ville: PropTypes.string,
        pays: PropTypes.shape({
            libelle: PropTypes.string.isRequired,
        }).isRequired,
        typeJustificatif: PropTypes.number,
        justificatifsDomicile: PropTypes.shape({
            fichiers: PropTypes.arrayOf(
                PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            ),
        }),
    }),
    isLoadingAdresse: PropTypes.bool,
    isLoadingBan: PropTypes.bool,
    dataBan: PropTypes.any,
    erreurModificationAdresse: PropTypes.bool,
    isLoadingModificationAdresse: PropTypes.bool,
    dataCodePostal: PropTypes.bool,
    dataCompteUsager: PropTypes.shape({
        personnePhysique: PropTypes.shape({
            uuid: PropTypes.string.isRequired,
        }).isRequired,
        responsableLegal: PropTypes.shape({
            uuid: PropTypes.string.isRequired,
        }),
    }),
    isLoadingVerificationCodeValidation: PropTypes.bool,
    erreurVerificationCodeValidation: PropTypes.string,
    messageVerificationCodeValidation: PropTypes.string,
};

export default connect(
    (state) => {
        const { data: dataAdresse, isLoading: isLoadingAdresse } =
            state.monCompte.recuperationAdressePrincipale;
        const { erreur: erreurModificationAdresse, isLoading: isLoadingModificationAdresse } =
            state.monCompte.modificationAdressePrincipale;
        const { isLoading: isLoadingBan, data: dataBan } = state.adresseVerificationBAN.verifier;
        const { data: dataCodePostal } = state.monCompte.verifierCodePostal;
        const { isLoading: isLoadingCompteUsager, data: dataCompteUsager } =
            state.monCompte.recupererInformationsPersonnelles;
        const {
            isLoading: isLoadingVerificationCodeValidation,
            erreur: erreurVerificationCodeValidation,
            message: messageVerificationCodeValidation,
        } = state.monCompte.verifierCodeValidation;
        return {
            isLoadingAdresse,
            dataAdresse,
            isLoadingBan,
            dataBan,
            isLoadingModificationAdresse,
            erreurModificationAdresse,
            dataCompteUsager,
            isLoadingCompteUsager,
            dataCodePostal,
            isLoadingVerificationCodeValidation,
            erreurVerificationCodeValidation,
            messageVerificationCodeValidation,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        putApi: putAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ModificationAdressePrincipale);
